module.exports = __webpack_public_path__ + "fonts/font.0981f74d.woff2";